import { useState } from "react";

import type { CentraAddress } from "../../Selection/formatters";
import { useConfig } from "../../useConfig";
import useToken from "../../useToken";
import usePaymentCallback from "./usePaymentCallback";

declare global {
  interface Window {
    CentraCheckout: any;
  }
}
export interface CheckoutAddress extends CentraAddress {
  termsAndConditions: boolean;
}

const useAdyen = () => {
  const { config } = useConfig();
  const { code } = usePaymentCallback();
  const { token } = useToken();
  const [checkoutHTML, setCheckoutHTML] = useState("");
  const [loading, setLoading] = useState(false);

  const initPayment = async (address: CentraAddress, comment: string) => {
    setLoading(true);

    if (!token) {
      throw new Error("Missing customer token key");
    }
    const apiUrl = config?.centra.url;
    if (window.CentraCheckout) window.CentraCheckout.suspend();
    const res = await fetch(
      `${apiUrl}/payment`,

      {
        method: "POST",
        body: JSON.stringify({
          paymentReturnPage: `${origin}${config?.giftCardUrl}`,
          paymentFailedPage: `${origin}${config?.giftCardUrl}`,
          termsAndConditions: true,
          paymentMethod: "adyen",
          address,
          giftMessage: comment,
        }),
        headers: {
          "Content-Type": "application/json",
          "API-Token": token || "",
        },
      }
    );

    const data = await res.json();
    if (window.CentraCheckout) window.CentraCheckout.resume();
    setCheckoutHTML(data.formHtml);
    setLoading(false);
  };

  return {
    initPayment,
    checkoutHTML,
    checkoutScript: code,
    loading,
  };
};

export default useAdyen;
